import Explorer from ".";

export const explorerRoutes = {
    routes: [
        {
            path: "/explorer",
            component: Explorer,
            exact: true,
        },
    ],
};